import { gql } from '@apollo/client'

const orderDetailsQuery = gql`
    query salesOrder($name: String!, $isCpqFlagV2Enabled: Boolean = false) {
        salesOrder(name: $name) {
            id
            isReorderAllowed
            isImReorder
            name
            deliveryStatus
            shippedBy
            createdAt
            totalAmount
            customerName
            fictivShipmentMethod
            fictivEstimatedDeliveryDate
            drawingAttachmentsCount
            sourceQuoteType
            depositAmount
            isBusinessAccountDiscountApplied
            appliedBusinessAccountDiscountPercent
            fictivOrderUpdatedToDdp
            fictivOrderModifiedPostSale
            team {
                id
                name
            }
            paymentDetails {
                id
                paidBy {
                    id
                    displayName
                }
                paidByDisplayName
                billingAddress {
                    id
                    name
                    street
                    street2
                    city
                    state
                    postalCode
                    phone
                    country
                }
                paymentType
                purchaseOrderNumber
                creditCardLast4
            }
            shipments {
                totalCount
                items {
                    id
                    deliveryStatus
                    carrier
                    shippedBy
                    shippingMethod
                    trackingCode
                    shipToAddress {
                        name
                        street
                        street2
                        city
                        stateCode
                        stateName
                        zip
                        countryCode
                        countryName
                        companyName
                        phone
                    }
                    committedDeliveryDate
                    trackingData {
                        status
                        estDeliveryDate
                        signedBy
                        trackingDetails {
                            message
                            status
                            datetime
                            trackingLocation {
                                city
                                state
                                countryCode
                                postalCode
                            }
                        }
                    }
                    shipmentLines {
                        totalCount
                        items {
                            revision {
                                id
                            }
                            woAvailableToShow
                            inspectionDocuments {
                                fileName
                            }
                        }
                    }
                }
            }
            salesOrderLines(limit: 100) {
                totalCount
                items {
                    id
                    htsCode
                    htsCodeSubmitted
                    htsDescription
                    htsApplication
                    htsUsageType
                    deliveryStatus
                    quantity
                    unitPrice
                    processName
                    productionRegion
                    processes {
                        id
                        color
                        texture
                        thickness
                        processNotes
                        additionalSpecifications {
                            color
                            texture
                            thickness
                        }
                        dfmNotes {
                            color
                            process
                            texture
                            thickness
                        }
                    }
                    revision {
                        id
                        modelFileName
                        thumbnailUri
                    }
                    quoteModelRevisionAttachment {
                        id
                        fileName
                    }
                    quoteModelRevision {
                        id
                        dfmReports {
                            isPublished
                        }
                        quoteModel {
                            id
                            quote {
                                id
                                name
                            }
                        }
                        modelConfiguration {
                            fdmInfillPercentageCategoryLabel
                            color {
                                name
                            }
                            process {
                                id
                            }
                        }
                    }
                }
                parts {
                    id
                    htsCode
                    htsCodeSubmitted
                    htsDescription
                    htsApplication
                    htsUsageType
                    deliveryStatus
                    quantity
                    unitPrice
                    processName
                    productionRegion
                    processes {
                        id
                        color
                        texture
                        thickness
                        processNotes
                        additionalSpecifications {
                            color
                            texture
                            thickness
                        }
                        dfmNotes {
                            color
                            process
                            texture
                            thickness
                        }
                    }
                    revision {
                        id
                        modelFileName
                        thumbnailUri
                    }
                    quoteModelRevisionAttachment {
                        id
                        fileName
                    }
                    quoteModelRevision {
                        id
                        dfmReports {
                            isPublished
                        }
                        quoteModel {
                            id
                            quote {
                                id
                                name
                            }
                        }
                        modelConfiguration {
                            fdmInfillPercentageCategoryLabel
                            color {
                                name
                            }
                            process {
                                id
                            }
                        }
                    }
                }
            }
            project {
                id
                isSecurePlus
                name
            }
            quoteId
            quote {
                name
            }
            quoteOwnerUser {
                id
            }
            quotePdfUrl @include(if: $isCpqFlagV2Enabled)
        }
    }
`

export default orderDetailsQuery
